export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  // supabase: Supabase Auth · api: the API's built-in sign-in (AUTH_PROVIDER=local) · dev: local development
  authMode: ((import.meta.env.VITE_AUTH_MODE as string | undefined) ?? 'supabase') as 'supabase' | 'api' | 'dev',
};
